import { IconButton, IconButtonProps } from '@mui/material';
import { Icon } from 'components/index';
import { useMenu } from 'hooks';
import MessageDropdownMenu from 'pages/app-pages/messages-scheduler-page/MessageDropdownMenu';

interface BotMenuWrapperProps extends IconButtonProps {
  id: string;
  icon: string;
}

const MessageDropdownWrapper = ({ id, icon, ...rest }: BotMenuWrapperProps) => {
  const { openMenu, isMenuOpen, ...restMenu } = useMenu();

  return (
    <>
      <IconButton onClick={openMenu} color='primary' aria-label='settings' {...rest}>
        <Icon icon={icon} fontSize='small' />
      </IconButton>
      {isMenuOpen && (
        <MessageDropdownMenu openMenu={openMenu} isMenuOpen={isMenuOpen} id={id} {...restMenu} />
      )}
    </>
  );
};

export default MessageDropdownWrapper;
